import { AgentsModule } from '@agents/agents.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RpcControlsModule } from '@core-controls/controls.module';
import { locale as english } from '@core-layout/toolbar/i18n/en';
import { ToolbarComponent } from '@core-layout/toolbar/toolbar.component';
import { TranslationLoaderService } from '@core-services/translation-loader.service';

import { NotificationsModule } from '@notifications/notifications.module';
import { UsersModule } from '@users/users.module';
import { ProfileBaseModule } from 'app/modules/user-modules/profile-modules/profile-base/profile-base.module';
import { SavedSearchModule } from '@saved-search/saved-search.module';
import { LogoModule } from '@core-layout/logo/logo.module';
import { RpcDirectivesModule } from '@core-directives/directives.module';

@NgModule({
    imports: [
    // Library Modules
    CommonModule,
    TranslateModule,
    RouterModule,
    // Application Modules
    AgentsModule,
    UsersModule,
    RpcControlsModule,
    NotificationsModule,
    ProfileBaseModule,
    SavedSearchModule,
    LogoModule,
    RpcDirectivesModule,
    ToolbarComponent
],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
    constructor(private readonly translationLoaderService: TranslationLoaderService) {
        this.translationLoaderService.loadTranslations(english);
    }
}